module.exports = __webpack_public_path__ + "img/1.63b8d6fb.jpeg";